import FormTextBox from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import { IMateriaulGridOps } from "../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";

const NewUser = () => {
  return [
    {
        label: "signup.form.first_name",
        keyName: "first_name",
        Component: FormTextBox,
        gridColumnOptions: { formCol: 6 as IMateriaulGridOps },
        registerOptions: {
          required: true,
          pattern: /^([A-Za-z])+$/,
        },
    },
    {
        label: "signup.form.last_name",
        keyName: "last_name",
        Component: FormTextBox,
        gridColumnOptions: { formCol: 6 as IMateriaulGridOps },
        registerOptions: {
          required: true,
          pattern: /^([A-Za-z])+$/,
        },
    },
  ];
}

export default NewUser;
